import { render, staticRenderFns } from "./RoleEditorModal.vue?vue&type=template&id=1cc0c7ed&scoped=true"
import script from "./RoleEditorModal.vue?vue&type=script&lang=js"
export * from "./RoleEditorModal.vue?vue&type=script&lang=js"
import style0 from "./RoleEditorModal.vue?vue&type=style&index=0&id=1cc0c7ed&prod&scoped=true&lang=css"
import style1 from "./RoleEditorModal.vue?vue&type=style&index=1&id=1cc0c7ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0c7ed",
  null
  
)

export default component.exports